import React, { useState } from 'react';
import confetti from 'canvas-confetti'; // Import confetti
import ctaThumb from '../../assets/images/cta/3.png';
import ctaShape1 from '../../assets/images/cta/2.png';
import ctaShape2 from '../../assets/images/cta/4.png';
import ctaShape3 from '../../assets/images/cta/5.png';

const Subscribe = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(''); // 'idle', 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  // Email validation
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  // Trigger confetti explosion
  const triggerConfetti = () => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: ['#ffffff', '#a8e6cf', '#ffd93d', '#ff6b6b'],
      gravity: 0.8,
      scalar: 1.2,
      ticks: 200,
    });

    // Additional burst from sides
    setTimeout(() => {
      confetti({
        particleCount: 50,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
      });
      confetti({
        particleCount: 50,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
      });
    }, 250);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setStatus('error');
      setMessage('Please enter your email.');
      return;
    }

    if (!validateEmail(email)) {
      setStatus('error');
      setMessage('Please enter a valid email address.');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      // Replace with your real API
      const response = await fetch('https://api.example.com/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setStatus('success');
        setMessage('Thank you! You have successfully subscribed.');
        setEmail('');
        triggerConfetti(); // CONFETTI ON SUCCESS
      } else {
        const error = await response.json();
        setStatus('error');
        setMessage(error.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setStatus('error');
      setMessage('Network error. Please check your connection and try again.');
    }
  };

  return (
    <div>
      {/* ========== STYLES + ANIMATIONS + CONFETTI READY ========== */}
      <style>
        {`
          .cta__newsletter-inner {
            background: linear-gradient(135deg, #000080 0%, #000000 100%) !important;
            position: relative;
            border-radius: 16px;
            overflow: hidden;
            padding: 40px 30px;
            color: #fff !important;
            box-shadow: 0 10px 30px rgba(0, 0, 128, 0.3);
          }

          .cta__subscribe h2,
          .cta__subscribe p {
            color: #ffffff !important;
          }
          .cta__subscribe h2 span {
            color: #ffffff !important;
            font-weight: bold;
          }

          .cta-form__inner .form-control {
            background: rgba(255, 255, 255, 0.15) !important;
            border: 1px solid rgba(255, 255, 255, 0.3) !important;
            color: #fff !important;
            border-radius: 8px;
            padding: 12px 16px;
            transition: all 0.3s ease;
          }
          .cta-form__inner .form-control::placeholder {
            color: rgba(255, 255, 255, 0.7) !important;
          }
          .cta-form__inner .form-control:focus {
            outline: none;
            border-color: #fff !important;
            box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3) !important;
            transform: scale(1.02);
          }

          .trk-btn--secondary2 {
            background: #ffffff !important;
            color: #000080 !important;
            font-weight: bold;
            border-radius: 8px;
            padding: 12px 28px;
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            position: relative;
            overflow: hidden;
          }
          .trk-btn--secondary2:hover {
            background: #f0f0f0 !important;
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
          }

          @keyframes pulse {
            0% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4); }
            70% { box-shadow: 0 0 0 10px rgba(255, 255, 255, 0); }
            100% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); }
          }
          .trk-btn--secondary2:hover {
            animation: pulse 1.5s infinite;
          }

          .status-message {
            margin-top: 16px;
            font-size: 0.95rem;
            text-align: center;
            opacity: 0;
            transform: translateY(-10px);
            animation: fadeInUp 0.5s ease forwards;
          }
          @keyframes fadeInUp {
            to { opacity: 1; transform: translateY(0); }
          }
          .status-success { color: #a8e6cf; }
          .status-error { color: #ff6b6b; }
          .status-loading { color: #ffd93d; }

          .animate-text > * {
            opacity: 0;
            transform: translateY(20px);
            animation: fadeInUp 0.6s ease forwards;
          }
          .animate-text h2 { animation-delay: 0.2s; }
          .animate-text p { animation-delay: 0.4s; }
          .animate-text form { animation-delay: 0.6s; }
        `}
      </style>

      <section className="cta padding-top padding-bottom bg-color">
        <div className="container">
          <div className="">
            <div className="cta__newsletter justify-content-center">
              <div
                className="cta__newsletter-inner"
                DataAos="fade-up"
                DataAos-duration="1000"
                DataAos-once="true"
              >
                <div className="cta__thumb">
                  <img src={ctaThumb} alt="cta-thumb" DataAos="fade-right" DataAos-delay="300" />
                </div>

                <div className="cta__subscribe animate-text">
                  <h2>
                    <span>Subscribe</span> our news
                  </h2>
                  <p>
                    Hey! Are you tired of missing out on our updates? Subscribe
                    to our news now and stay in the loop!
                  </p>

                  <form
                    className="cta-form cta-form--style2 form-subscribe"
                    onSubmit={handleSubmit}
                  >
                    <div className="cta-form__inner d-sm-flex align-items-center">
                      <input
                        type="email"
                        className="form-control form-control--style2 mb-3 mb-sm-0"
                        placeholder="Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={status === 'loading'}
                      />
                      <button
                        className="trk-btn trk-btn--large trk-btn--secondary2"
                        type="submit"
                        disabled={status === 'loading'}
                      >
                        {status === 'loading' ? 'Submitting...' : 'Submit'}
                      </button>
                    </div>

                    {/* Status Message */}
                    {message && (
                      <div className={`status-message status-${status}`} role="alert">
                        {message}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>

            {/* Decorative Shapes */}
            <div className="cta__shape">
              <span className="cta__shape-item cta__shape-item--1" DataAos="fade-up" DataAos-delay="200">
                <img src={ctaShape1} alt="shape icon" />
              </span>
              <span className="cta__shape-item cta__shape-item--2" DataAos="fade-up" DataAos-delay="400">
                <img src={ctaShape2} alt="shape icon" />
              </span>
              <span className="cta__shape-item cta__shape-item--3" DataAos="fade-up" DataAos-delay="600">
                <img src={ctaShape3} alt="shape icon" />
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Subscribe;